export const FareCalculator = (distance,time,rateDetails,instructionData, decimal)=>{

    // Coercion defensiva: algunos campos de tarifa pueden venir como texto desde
    // la base de datos (p. ej. "5000"). Si se suman directamente a un numero,
    // JavaScript concatena cadenas y el resultado deja de ser numero, lo que hace
    // que total.toFixed(...) falle con "undefined is not a function".
    const num = (v) => {
        const n = parseFloat(v);
        return isNaN(n) ? 0 : n;
    };

    const dec = Number.isInteger(parseInt(decimal)) ? parseInt(decimal) : 2;

    const ratePerDistance = num(rateDetails && rateDetails.rate_per_unit_distance);
    const ratePerHour = num(rateDetails && rateDetails.rate_per_hour);
    const baseFare = num(rateDetails && rateDetails.base_fare);
    const minFare = num(rateDetails && rateDetails.min_fare);

    let baseCalculated = (ratePerDistance * num(distance)) + (ratePerHour * (num(time) / 3600));
    if (baseFare > 0) {
        baseCalculated = baseCalculated + baseFare;
    }
    if (instructionData && instructionData.parcelTypeSelected) {
        baseCalculated = baseCalculated + num(instructionData.parcelTypeSelected.amount);
    }
    if (instructionData && instructionData.optionSelected) {
        baseCalculated = baseCalculated + num(instructionData.optionSelected.amount);
    }

    let total = baseCalculated > minFare ? baseCalculated : minFare;

    let convenienceFee = 0;
    if (rateDetails && rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat') {
        convenienceFee = num(rateDetails.convenience_fees);
    } else {
        convenienceFee = (total * num(rateDetails && rateDetails.convenience_fees) / 100);
    }

    let grand = total + convenienceFee;

    return {
        totalCost: parseFloat(total.toFixed(dec)),
        grandTotal: parseFloat(grand.toFixed(dec)),
        convenience_fees: parseFloat(convenienceFee.toFixed(dec))
    }

}
